import { TOPIC_NAMES } from './MessageTopics';

export const COMMAND_TOPICS = [
  TOPIC_NAMES.SHOW_ALERT,
  TOPIC_NAMES.OPEN_OBJECT_BUILDER,
  TOPIC_NAMES.PREVIEW_OBJECT,
  TOPIC_NAMES.OPEN_WORK_OBJECT_PREVIEW,
  TOPIC_NAMES.PREVIEW_ENGAGEMENT,
  TOPIC_NAMES.OPEN_ACTIVITY_CREATOR,
  TOPIC_NAMES.OPEN_PLAYBOOK_WINDOW,
  TOPIC_NAMES.OPEN_UPDATE_ASSOCIATION_MODAL,
  TOPIC_NAMES.OPEN_IFRAME_MODAL,
  TOPIC_NAMES.OPEN_PROPERTY_HISTORY,
  TOPIC_NAMES.OPEN_DEAL_SCORE_HISTORY,
  TOPIC_NAMES.OPEN_CARD_USER_CUSTOMIZATION,
  TOPIC_NAMES.OPEN_COLLAB_SIDEBAR,
  TOPIC_NAMES.OPEN_ATTACHMENTS_MODAL,
  TOPIC_NAMES.OPEN_ATTACHMENTS_FILE_MANAGER,
  TOPIC_NAMES.OPEN_ATTACHMENTS_REMOVE_MODAL,
  TOPIC_NAMES.OPEN_DATA_AGENT_PANEL,
  TOPIC_NAMES.OPEN_ENRICHMENT_PROPERTIES_PANEL,
  TOPIC_NAMES.OPEN_SMART_PROPERTIES_PANEL,
  TOPIC_NAMES.OPEN_CONTACT_SOURCING_PANEL,
  TOPIC_NAMES.OPEN_ACTIVITY_QUICK_VIEW_MODAL,
  TOPIC_NAMES.OPEN_ACTIVITY_TIMELINE_SIDEBAR,
  TOPIC_NAMES.OPEN_DEAL_SPLITS_SIDEBAR,
  TOPIC_NAMES.OPEN_DEAL_SPLITS_DELETE_MODAL,
  TOPIC_NAMES.OPEN_DEAL_COLLABORATORS_DELETE_MODAL,
  TOPIC_NAMES.OPEN_SCORE_HISTORY,
  TOPIC_NAMES.OPEN_RECENT_PRODUCTS,
  TOPIC_NAMES.OPEN_DEAL_REGISTRATION_SUMMARY,
  TOPIC_NAMES.OPEN_MULTI_ACCOUNT_PANEL,
  TOPIC_NAMES.OPEN_PORTAL_USERS_PANEL,
  TOPIC_NAMES.OPEN_REPLACE_PINNED_ENGAGEMENT_MODAL,
  TOPIC_NAMES.OPEN_DELETE_ENGAGEMENT_MODAL,
  TOPIC_NAMES.OPEN_DELETE_SCHEDULED_EMAIL_MODAL,
  TOPIC_NAMES.OPEN_DELETE_DRAFT_EMAIL_MODAL,
  TOPIC_NAMES.OPEN_DELETE_TASK_MODAL,
  TOPIC_NAMES.OPEN_TASK_QUEUE,
  TOPIC_NAMES.COMMAND_HANDLER_PING,
  TOPIC_NAMES.OPEN_MERGE_OBJECTS_MODAL,
  TOPIC_NAMES.OPEN_UNMERGE_OBJECTS_MODAL,
  TOPIC_NAMES.OPEN_CLONE_OBJECTS_MODAL,
  TOPIC_NAMES.OPEN_REVIEW_ASSOCIATIONS_MODAL,
  TOPIC_NAMES.OPEN_HIDE_EMAIL_TRACKING_MODAL,
  TOPIC_NAMES.OPEN_ALL_PROPERTIES_PANEL,
  TOPIC_NAMES.OPEN_EMAIL_TRACKING_CONSENT_PANEL,
  TOPIC_NAMES.OPEN_NEXT_STEPS_PANEL,
  TOPIC_NAMES.OPEN_ASSOCIATION_HISTORY_PANEL,
  TOPIC_NAMES.OPEN_INFLUENCED_CAMPAIGNS_PANEL,
  TOPIC_NAMES.OPEN_EDIT_CAMPAIGN_ENGAGEMENT_MODAL,
  TOPIC_NAMES.OPEN_EDIT_CAMPAIGN_MARKETING_EVENT_MODAL,
  TOPIC_NAMES.OPEN_EDIT_CAMPAIGN_ASSET_MODAL,
  TOPIC_NAMES.OPEN_INVOICE_MODAL,
  TOPIC_NAMES.OPEN_INVOICE_ACTION_MODAL,
  TOPIC_NAMES.OPEN_INVOICE_SEND_EMAIL_MODAL,
  TOPIC_NAMES.OPEN_CREDIT_MEMO_MODAL,
  TOPIC_NAMES.OPEN_CALL_TRANSCRIPT_SIDEBAR,
  TOPIC_NAMES.OPEN_ADD_POI_MODAL,
  TOPIC_NAMES.OPEN_SALES_ORDER_WIZARD,
  TOPIC_NAMES.OPEN_QUALIFIED_LEADS_HISTORY_PANEL,
  TOPIC_NAMES.OPEN_RAISE_A_LEAD_PANEL,
  TOPIC_NAMES.OPEN_BILLING_WIZARD_MODAL,
  TOPIC_NAMES.OPEN_SUBSCRIPTIONS_ADMIN_MODAL,
  TOPIC_NAMES.OPEN_RESTORE_REQUEST_SIDE_PANEL,
  TOPIC_NAMES.OPEN_RECENT_CONVERSION_HISTORY_PANEL,
  TOPIC_NAMES.OPEN_DEAL_SUPPORT_REQUEST_PANEL,
  TOPIC_NAMES.OPEN_SALES_MANAGER_ESCALATION_PANEL,
  TOPIC_NAMES.OPEN_MANAGE_RECORD_ACCESS_PANEL,
  TOPIC_NAMES.OPEN_SHARE_ENGAGEMENT_ACCESS_MODAL,
  TOPIC_NAMES.OPEN_UNIVERSAL_RECORD,
  TOPIC_NAMES.OPEN_WORKFLOW_ENROLLMENT_MODAL,
  TOPIC_NAMES.OPEN_SEQUENCE_ENROLLMENT_MODAL,
  TOPIC_NAMES.OPEN_EXISTING_SEQUENCE_ENROLLMENT_MODAL,
  TOPIC_NAMES.OPEN_SEQUENCE_UNENROLL_MODAL,
  TOPIC_NAMES.OPEN_CONTRACT_TERMINATE_MODAL,
  TOPIC_NAMES.OPEN_CONTRACT_MANAGE_TERMINATION_MODAL,
  TOPIC_NAMES.OPEN_CONTRACT_CANCEL_TERMINATION_MODAL,
  TOPIC_NAMES.OPEN_CONTRACT_CHANGE_QUOTE_MODAL,
  TOPIC_NAMES.OPEN_CONTRACT_CANCEL_CHANGE_QUOTE_MODAL,
  TOPIC_NAMES.OPEN_CONTRACT_UPDATE_PAYMENT_METHOD_MODAL,
  TOPIC_NAMES.OPEN_CONTRACT_RENEWAL_QUOTE_MODAL,
  TOPIC_NAMES.OPEN_CONTRACT_CANCEL_RENEWAL_QUOTE_MODAL,
  TOPIC_NAMES.OPEN_CONTRACT_DELETE_MODAL,
  TOPIC_NAMES.OPEN_CONTRACT_EDIT_MODAL,
  TOPIC_NAMES.OPEN_CONTRACT_RENEW_MODAL,
  TOPIC_NAMES.OPEN_CONTRACT_PAUSE_MODAL,
  TOPIC_NAMES.OPEN_CONTRACT_RESUME_MODAL,
  TOPIC_NAMES.OPEN_CREATE_DEAL_PLAN_MODAL,
  TOPIC_NAMES.OPEN_DELETE_DEAL_PLAN_MODAL,
  TOPIC_NAMES.OPEN_REPLACE_BILLING_CONTACT_MODAL,
  TOPIC_NAMES.OPEN_PROSPECTING_AGENT_MODAL,
  TOPIC_NAMES.OPEN_ROUTING_ASSIGNMENT_DETAILS_PANEL,
  TOPIC_NAMES.OPEN_SMART_DATA_CAPTURE_MODAL,
  TOPIC_NAMES.OPEN_BUYING_GROUP_CANVAS_MODAL,
  TOPIC_NAMES.OPEN_ACCOUNT_MAP_CANVAS_MODAL,
  TOPIC_NAMES.OPEN_IMPORT_CONTACTS_MODAL,
  TOPIC_NAMES.OPEN_MARKETING_EVENT_CONTACTS_MODAL,
  TOPIC_NAMES.OPEN_CUSTOM_ENGAGEMENT_PROPERTY_SETTINGS,
  TOPIC_NAMES.OPEN_MANAGE_OWNERSHIP_MODAL,
  TOPIC_NAMES.OPEN_REMOVE_AND_RECYCLE_PANEL,
  TOPIC_NAMES.OPEN_REJECT_LEAD_MODAL,
  TOPIC_NAMES.OPEN_DISPUTE_DOMAIN_MODAL,
  TOPIC_NAMES.OPEN_ENRICH_DOMAIN_MODAL,
  TOPIC_NAMES.OPEN_CHANGE_DOMAIN_URL_MODAL,
  TOPIC_NAMES.OPEN_MOVE_CONTACT_MODAL,
  TOPIC_NAMES.OPEN_REMOVE_BAD_FIT_MODAL,
  TOPIC_NAMES.OPEN_DOMAIN_HISTORY_PANEL,
  TOPIC_NAMES.OPEN_QUOTE_EDITOR,
  TOPIC_NAMES.OPEN_CPQ_QUOTE_SIDEBAR,
  TOPIC_NAMES.OPEN_PROSPECTING_OUTREACH,
  TOPIC_NAMES.OPEN_PRODUCT_EDITOR,
  TOPIC_NAMES.OPEN_PROPERTY_DOCUMENTATION,
  TOPIC_NAMES.OPEN_CREATE_PROPERTY_PANEL,
  TOPIC_NAMES.OPEN_PROPERTY_FILE_DETAILS_PANEL,
  TOPIC_NAMES.OPEN_CREATE_PAYMENT_PLAN,
  TOPIC_NAMES.OPEN_EDIT_PAYMENT_PLAN,
  TOPIC_NAMES.OPEN_CANCEL_PAYMENT_PLAN,
  TOPIC_NAMES.OPEN_PAYMENT_LINK_IFRAME,
  TOPIC_NAMES.OPEN_FLYWHEEL_COLD_SOURCE_MODAL,
  TOPIC_NAMES.OPEN_PAYMENT_LINK_ASSOCIATION_PANEL,
  TOPIC_NAMES.OPEN_PAYMENT_LINK_CREATE_MODAL,
  TOPIC_NAMES.OPEN_NBA_RECOMMENDATIONS_SIDEBAR,
  TOPIC_NAMES.OPEN_INTENT_SIGNALS_TRACKING,
  TOPIC_NAMES.EXPAND_RIGHT_SIDEBAR,
  TOPIC_NAMES.OPEN_INTENT_SIGNALS_SIDEBAR,
] as const;

export type CommandTopic = (typeof COMMAND_TOPICS)[number];
